import { cn } from '#/shared/lib/utils'

interface ToolbarProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Toolbar({ className, ...props }: ToolbarProps) {
  return <div className={cn('flex flex-col gap-2.5', className)} {...props} />
}

function ToolbarBar({ className, ...props }: ToolbarProps) {
  return (
    <div
      className={cn('flex min-h-8 items-center justify-between', className)}
      {...props}
    />
  )
}

function ToolbarGroup({ className, ...props }: ToolbarProps) {
  return (
    <div className={cn('flex items-center gap-2.5', className)} {...props} />
  )
}

function ToolbarFilters({ className, ...props }: ToolbarProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2.5 animate-slide-down',
        className,
      )}
      {...props}
    />
  )
}

Toolbar.Bar = ToolbarBar
Toolbar.Left = ToolbarGroup
Toolbar.Right = ToolbarGroup
Toolbar.Filters = ToolbarFilters
